import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { debounce } from "lodash";
import { nextTick, onMounted, ref, watch } from "vue";
import { CapSuaChuaService } from "@/core/services/CapSuaChuaService.service";
import { ICapSuaChuaResponseBase } from "@/core/interfaces/ApiResponses";
import { swalErrNotification } from "@/core/helpers/utils";
import { useLoading } from "@/core/hooks/use-loading";
import { usePagination } from "@/core/hooks/use-pagination";
import { usePageHeader } from "@/core/hooks/usePageHeader";
import { CAP_SUA_CHUA } from "@/core/constants/permissions";
import { useRouter } from "vue-router";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import CapSuaChuaTable from "@/components/shared/cap-sua-chua-table/CapSuaChuaTable.vue";
import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import PageHeaderActions from "@/layout/header/PageHeaderActions.vue";
import PageHeaderActionItem from "@/layout/header/PageHeaderActionItem.vue";
import Pagination from "@/components/shared/pagination/Pagination.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

document.title = "Cấp sửa chữa - Đường sắt Hà Nội";

const { currentPage, perPage, totalItems } = usePagination();
const capSuaChuaItems = ref<ICapSuaChuaResponseBase[]>([]);
const { endLoading, startLoading } = useLoading();
const { push, resolve } = useRouter();

const { searchQuery } = usePageHeader({
  title: "Danh sách cấp sửa chữa",
  breadcrumbs: [{ text: "Cấp sửa chữa" }],
  showSearch: true,
  searchPlaceholder: "Nhập để tìm kiếm",
  addLabel: "Thêm cấp s/chữa",
  addPermissions: [CAP_SUA_CHUA.TAO_MOI],
  onAdd: () => push({ name: "tao-moi-cap-sua-chua" }),
});

const openPrintViewer = () => {
  const route = resolve({
    name: "xem-danh-sach-cap-sua-chua",
    query: searchQuery.value ? { s: searchQuery.value } : {},
  });

  window.open(route.href, "_blank");
};

const onPageChange = (page: number) => {
  currentPage.value = page;
};

const onPageSizeChange = (size: number) => {
  perPage.value = size;
};

const fetchData = async () => {
  await startLoading();

  try {
    const {
      data: {
        data: { total, data },
      },
    } = await CapSuaChuaService.list({
      current_page: currentPage.value,
      per_page: perPage.value,
      s: searchQuery.value,
    });

    totalItems.value = total;
    capSuaChuaItems.value = data;
    await endLoading();
  } catch (error) {
    await endLoading();
    await swalErrNotification(error, "Có lỗi xảy ra");
  }
};

onMounted(async () => {
  await fetchData();
});

watch(
  () => currentPage.value,
  () => {
    fetchData();
  }
);

watch(
  () => perPage.value,
  () => {
    nextTick().then(() => {
      if (currentPage.value === 1) {
        fetchData();
        return;
      }
      currentPage.value = 1;
    });
  }
);

watch(searchQuery, debounce(() => {
  nextTick().then(() => {
    if (currentPage.value === 1) {
      fetchData();
      return;
    }
    currentPage.value = 1;
  });
}, 500));

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(PageContentBase, null, {
    default: _withCtx(() => [
      _createVNode(PageHeaderActions, null, {
        default: _withCtx(() => [
          _createVNode(PageHeaderActionItem, { onClick: openPrintViewer }, {
            icon: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: _unref(faPrint) }, null, 8, ["icon"])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Xem danh sách cấp sửa chữa (PDF) ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(CapSuaChuaTable, {
        "cur-page": _unref(currentPage),
        items: capSuaChuaItems.value,
        "per-page": _unref(perPage)
      }, null, 8, ["cur-page", "items", "per-page"]),
      (_unref(totalItems) > 0)
        ? (_openBlock(), _createBlock(Pagination, {
            key: 0,
            page: _unref(currentPage),
            "page-size": _unref(perPage),
            total: _unref(totalItems),
            onChangePage: onPageChange,
            onChangePageSize: onPageSizeChange
          }, null, 8, ["page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})